module.exports = __webpack_public_path__ + "media/images/promo/championship/Steps_n-cc9417b1f24267b0ff4a1f4ca4e8aa66.png";